import { notificationActions } from "./notifications-slice";

export function GetNotificationData() {
  return async (dispatch) => {

    dispatch(notificationActions.replaceNotification([]))
  }
};
